import { useAppDispatch } from 'store/hooks';
import React from 'react';

import { MainLayout } from 'layouts/MainLayout';
import { LocationScopedSettings } from 'components/settings/LocationScopedSettings';
import { PointOfSaleSettings } from 'components/settings/PointOfSaleSettings';
import { MERCHANT_MOBILE_SETTINGS } from 'config/routes';
import { getPosLocations } from 'store/pos-locations/posLocationsSlice';

export const PointOfSaleSettingsPage: React.FC = () => {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(getPosLocations());
    }, [dispatch]);

    return (
        <MainLayout
            pageName="Point of Sale Settings"
            pageDescription="Adjust your point of sale settings."
            breadcrumbs={[{ label: 'Settings', url: MERCHANT_MOBILE_SETTINGS }]}
        >
            <LocationScopedSettings
                globalComponent={PointOfSaleSettings}
                scopedComponent={PointOfSaleSettings}
            />
        </MainLayout>
    );
};
